import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import RemoteVideo from '../RemoteVideo';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import MessageBox from '../../../chat/components/Footer';
import OverlayMessages from '../OverlayMessages';
import JobsTab from '../jobs/JobsTab';
import Content from '../../../shared/components/Content';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`wrapped-tabpanel-${index}`}
      aria-labelledby={`wrapped-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </Typography>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `wrapped-tab-${index}`,
    'aria-controls': `wrapped-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
  tab: {
    maxHeight: 48,
    '& .MuiTab-wrapper': {
      alignItems: 'flex-start',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      display: 'block',
    }
  }
}));

export default function CompanyTabs(props) {
  const classes = useStyles();
  let firstTab = props.broadcastEnabled ? 'live' : ( props.contents[0] ? props.contents[0].slug : 'jobs' );
  const [value, setValue] = React.useState(firstTab);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const resetSelectedJob = () => {
    props.JobBackClick();
  }

  const sendMessage = (msg) => {
    if( msg != '' ) {
      props.sendMessage(msg);
    }
  };

  return (
    <div className={classes.root}>
      <AppBar position="static">
        <Tabs value={value} onChange={handleChange} aria-label="label tabs" variant="scrollable" scrollButtons="on">
          { props.broadcastEnabled ?
            (<Tab key="live" value="live" label="Live stream" {...a11yProps('live')} />)
          : null }

          { props.contents.map( (content) =>
            (<Tab className={classes.tab} key={content.slug} value={content.slug} label={content.title} wrapped={false} />) )
          }

          { props.jobsPresent ?
            <Tab key="jobs" value="jobs" label="Jobs" {...a11yProps('jobs')} onClick={resetSelectedJob} />
          : null }
        </Tabs>
      </AppBar>
      { props.broadcastEnabled ?
      (<TabPanel value={value} index="live" key="live">
        <div style={{position: 'relative', paddingBottom: 68}}>
          <RemoteVideo stream={props.stream} />
          { props.stream ?
          <>
            <OverlayMessages messages={props.messages} />
            <MessageBox label="Ask a question" sendMessage={sendMessage} />
          </>
          : null }
        </div>
      </TabPanel>) : null }

      { props.contents.map( (content) =>
      (<TabPanel value={value} index={content.slug} key={content.slug}>
        <Content content={content} />
      </TabPanel>))
      }

      { props.jobsPresent ?
      <TabPanel value={value} index="jobs" key="jobs">
        <JobsTab {...props} />
      </TabPanel>
      : null }

    </div>
  );
}
